import {all} from 'redux-saga/effects'
import {watchGetProviderAsync} from './sagas/getprovider';
import {watchResetPasswordAsync} from "./sagas/resetpassword";
import {watchLoginAsync} from "./sagas/login";
import {watchValidatePasswordAsync} from "./sagas/validatePassword";


export default function* rootSaga() {
  yield all([
    watchGetProviderAsync(),
    watchLoginAsync(),
    watchResetPasswordAsync(),
    watchValidatePasswordAsync(),
  ])
}